import React, { FC } from 'react';

import AppFiledBox from 'components/appComponents/app-field-box';
import { useAuth } from 'context/auth';
import { TextArea } from 'devextreme-react';

import { PaymentMethod } from 'bus/contractorNomenclaturePrice/types';

type Props = {
  paymentMethod: PaymentMethod | null;
  valueText: string;
  onChangeText: (value: string) => void;
  readOnly: boolean;
};

const Barter: FC<Props> = ({ paymentMethod, valueText, onChangeText, readOnly }) => {
  const { getClaims }: any = useAuth();
  const hasPermission = getClaims(['CanSetBarterValue']);

  return (
    <div>
      {paymentMethod === 2 && (
        <AppFiledBox label="Комментарий для бартера" labelTop>
          <TextArea
            stylingMode="underlined"
            placeholder="Введите комментарий  для бартера"
            mode="text"
            value={valueText}
            onChange={(e: any) => onChangeText(e.event.currentTarget.value)}
            maxLength={80}
            readOnly={!hasPermission}
            showClearButton
          />
        </AppFiledBox>
      )}
    </div>
  );
};

export default Barter;
